module.exports = __webpack_public_path__ + "static/media/4-item-b.738d4594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/4-item-b.jpg
// module id = 1168
// module chunks = 33